import { createContext, useContext } from "react"

interface IContext {
    setSnackbarOpen: (message: string, autoHideDuration?: number | null) => void
}

const initialContext = {
    setSnackbarOpen: () => { }
}

export const ProjectsTableContext = createContext<IContext>(initialContext)

export const useProjectsTableContext = () => useContext(ProjectsTableContext)